import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject} from '@angular/core';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {ClsConfig} from '../../../../util/cls-config';
import {ExcelUtility} from '../../../../util/excel-utility';
import {
  IgxSpreadsheetComponent,
  SpreadsheetCell,
  IgxSpreadsheetModule, IgxSpreadsheetEditModeEnteringEventArgs
} from 'igniteui-angular-spreadsheet';
import {IgxExcelModule, Workbook, WorksheetCell} from 'igniteui-angular-excel';
import {ClsUtil} from '../../../../util/cls-util';
import {TranslateModule} from '@ngx-translate/core';
import { IgxButtonDirective, IgxButtonModule, IgxRippleDirective } from '@infragistics/igniteui-angular/directives';
import { IgxCardModule } from '@infragistics/igniteui-angular/card';
import { IGX_CAROUSEL_DIRECTIVES } from '@infragistics/igniteui-angular/carousel';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent, IgxPrefixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IgxNavbarActionDirective, IgxNavbarComponent } from '@infragistics/igniteui-angular/navbar';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {FormsModule} from "@angular/forms";
import {ClsObjFasar} from "../../../../clases-pu/01-presupuesto/presupuesto/cls-obj-fasar";
import {ClsObjSobrecosto} from "../../../../clases-pu/01-presupuesto/presupuesto/cls-obj-sobrecosto";
import {ClsObjCostoHorario} from "../../../../clases-pu/01-presupuesto/presupuesto/cls-obj-costo-horario";
import {KeyVentanaPreviewExcel} from "../../../../core/models/enum/emun-enumeracion";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";

@Component({
  selector: 'app-vista-previa-excel',
  templateUrl: './vista-previa-excel.component.html',
  styleUrls: ['./vista-previa-excel.component.scss'],
  imports: [
    IgxCardModule,
    IGX_CAROUSEL_DIRECTIVES,
    IgxExcelModule,
    IgxSpreadsheetModule,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    TranslateModule,
    IgxNavbarComponent,
    IgxNavbarActionDirective,
    FormsModule,
    IgxIconComponent,
    IgxRippleDirective,
    IgxInputGroupComponent,
    IgxPrefixDirective,
  ]
})
export class VistaPreviaExcelComponent extends ClsConfig implements OnInit {
  private tipoMsg = inject(TipoMensajesService);

  @ViewChild('spreadsheet', {read: IgxSpreadsheetComponent, static: true})
  public spreadsheet: IgxSpreadsheetComponent;
  @ViewChild('inputDocumento', {read: IgxInputDirective, static: true})
  public inputDocumento: IgxInputDirective;

  @Input()
  public verCargarArchivo = false;
  @Input()
  public verBotones = false;
  @Input()
  public nombreDocumento: string = '';
  @Output()
  public guardarWorkbook: EventEmitter<Workbook> = new EventEmitter<Workbook>();

  private _INDEXHOJA: number;
  /**
   * Este campo sirve para indicar que ventana se esta invocando y mostando una vista previa del documento
   * para que cuando suba un nuevo documento desde aqui, se valide antes de ser guardado
   * @private
   */
  private _VENTANAPREVIEW: KeyVentanaPreviewExcel;

  public titulo: string;
  public tituloExportar: string;
  public icono: string;
  public altoVtn: number;
  public anchoVtn: number;
  private valorAnterior: number;
  // ventana
  public vtnGenerico: VtnGenericaComponent;


  get INDEXHOJA(): number {
    return this._INDEXHOJA;
  }

  set INDEXHOJA(value: number) {
    this._INDEXHOJA = value;
  }

  get VENTANAPREVIEW() {
    return this._VENTANAPREVIEW;
  }

  set VENTANAPREVIEW(value: KeyVentanaPreviewExcel) {
    this._VENTANAPREVIEW = value;
  }

  private clsObjFasar: ClsObjFasar = new ClsObjFasar();
  private clsObjSobrecosto: ClsObjSobrecosto = new ClsObjSobrecosto();
  private clsObjCostoHorario: ClsObjCostoHorario = new ClsObjCostoHorario();

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (!ClsUtil.esNulo(this.vtnGenerico)) {
      this.vtnGenerico.evtExportar.subscribe(async () => {
        await this.exportarExcel();
      });
    }
  }

  public open() {
    this.vtnGenerico.open(this.altoVtn, this.anchoVtn, this.titulo, this.icono);
  }

  public cargarLibro(workbook: Workbook, indexHoja: number) {
    this.INDEXHOJA = indexHoja;
    this.spreadsheet.workbook.culture = ClsUtil.obtenerLocalGrid();
    this.spreadsheet.workbook = workbook;
    // // CHANGE #1: force layout in one go
    // this.spreadsheet.flush();
    //
    // // CHANGE #2: resume calculations only now
    // workbook.resumeCalculations();
    this.spreadsheet.activeWorksheet = this.spreadsheet.workbook.worksheets(this.INDEXHOJA);
  }

  public activeWorksheetChanged() {
    this.spreadsheet.activeCell = new SpreadsheetCell('A1');
  }

  public editModeEntered(evt: any) {
    const args: IgxSpreadsheetEditModeEnteringEventArgs = evt.args;
    const celda: WorksheetCell = this.spreadsheet.activeWorksheet.rows(args.cell.row).cells(args.cell.column);
    this.valorAnterior = celda.value;
  }

  public editModeExited(evt: any): void {
    const args: IgxSpreadsheetEditModeEnteringEventArgs = evt.args;
    const celda: WorksheetCell = this.spreadsheet.activeWorksheet.rows(args.cell.row).cells(args.cell.column);
    const formato: string = celda.cellFormat.formatString ?? '';
    const valor: any = celda.value;
    const esPorcentaje = formato.includes('%');
    if (valor !== this.valorAnterior && esPorcentaje) {
      if (ClsUtil.checkIfDividedBy100(valor)) {
        celda.value = valor / 100;
      }
    }
  }

  public close() {
    this.vtnGenerico.close();
  }

  public guardarInfo() {
    this.guardarWorkbook.emit(this.spreadsheet.workbook);
  }

  public async openFile(input: any) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.GRALS.CARGANDO');
      const archivo: File = input.target.files[0];
      // validar si tienen las hojas necesarias para procesar el documento
      switch (this.VENTANAPREVIEW) {
        case KeyVentanaPreviewExcel.FASAR:
          await this.clsObjFasar.validarHojasFasarSubirArchivoLocal(archivo);
          break;
        case KeyVentanaPreviewExcel.COSTOHORARIO:
          await this.clsObjCostoHorario.validarHojasCHSubirArchivoLocal(archivo);
          break;
        case KeyVentanaPreviewExcel.SOBRECOSTO:
          await this.clsObjSobrecosto.validarHojasPIANDSCSubirArchivoLocal(archivo, true);
          break;
        case KeyVentanaPreviewExcel.PIEINDIRECTO:
          await this.clsObjSobrecosto.validarHojasPIANDSCSubirArchivoLocal(archivo, false);
          break;
      }
      const libro: Workbook = await ExcelUtility.load(archivo);
      this.nombreDocumento = archivo.name;
      this.cargarLibro(libro, this.INDEXHOJA);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      input.target.value = [];
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async exportarExcel() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GUARDANDO');
      await ExcelUtility.save(this.spreadsheet.workbook, this.tituloExportar);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }
}
